import i18n from '../../../../../../config/i18n';
import { formatNumberWithCurrency } from '../../../../../../helpers/invoiceHelpers';

export const LINE_ITEMS_COLUMNS = [
  {
    key: 'description',
    field: 'descriptionEn',
    label: 'createInvoice.goods_or_service_description',
    type: 'text',
    _props: { scope: 'col' },
    required: true,
    headerStyle: { width: '12rem' },
  },
  {
    key: 'unitPrice',
    field: 'unitPrice',
    label: 'createInvoice.unit_price',
    type: 'text',
    _props: { scope: 'col' },
    required: true,
    body: ({ data, field, currency }) =>
      formatNumberWithCurrency(
        Number(data[field?.id] || data[field.field]).toFixed(3),
        currency,
        i18n.language,
      ),
  },
  {
    key: 'quantity',
    field: 'quantity',
    label: 'createInvoice.quantity',
    type: 'text',
    _props: { scope: 'col' },
    required: true,
  },
  {
    key: 'discountPercentage',
    field: 'discountPercentage',
    label: 'createInvoice.discount_or_rebate_percentage',
    resetField: 'discountAmount',
    type: 'text',
    _props: { scope: 'col' },
    hasInfoIcon: true,
    tooltip: 'createInvoice.line_item_discount_tooltip',
    body: ({ data, field }) =>
      data[field?.id] || data[field.field]
        ? `${Number(data[field?.id] || data[field.field]).toFixed(2)}%`
        : '',
  },
  {
    key: 'discountAmount',
    field: 'discountAmount',
    label: 'createInvoice.discount_or_rebate_amount',
    resetField: 'discountPercentage',
    type: 'text',
    _props: { scope: 'col' },
    hasInfoIcon: true,
    tooltip: 'createInvoice.line_item_discount_tooltip',
    body: ({ data, field, currency }) =>
      formatNumberWithCurrency(
        data[field?.id] || data[field.field],
        currency,
        i18n.language,
      ),
  },
  {
    key: 'netAmount',
    field: 'netAmount',
    label: 'createInvoice.net_amount',
    _props: { scope: 'col' },
    body: ({ data, field, currency }) =>
      formatNumberWithCurrency(
        data[field?.id] || data[field.field],
        currency,
        i18n.language,
      ),
  },
  {
    key: 'vatRateType',
    field: 'vatRateType',
    label: 'createInvoice.vat_rate',
    type: 'select',
    _props: { scope: 'col' },
    required: true,
  },
  {
    key: 'vatAmount',
    field: 'vatAmount',
    label: 'createInvoice.vat_amount',
    _props: { scope: 'col' },
    body: ({ data, field, currency }) =>
      formatNumberWithCurrency(
        data[field?.id] || data[field.field],
        currency,
        i18n.language,
      ),
  },
  {
    key: 'totalAmount',
    field: 'totalAmount',
    label: 'createInvoice.total_incl_vat',
    _props: { scope: 'col' },
    body: ({ data, field, currency }) =>
      formatNumberWithCurrency(
        data[field?.id] || data[field.field],
        currency,
        i18n.language,
      ),
  },
];

export const LINE_ITEMS_COLUMNS_FIELDS = {
  description: {
    placeholder: 'Add item description',
    type: 'string',
    required: true,
    options: [],
  },
  unitPrice: {
    placeholder: '0.000',
    type: 'currency',
    required: true,
    options: [],
  },
  quantity: {
    placeholder: '0',
    type: 'number',
    required: true,
    options: [],
  },
  discountPercentage: {
    placeholder: '0.00%',
    type: 'percentage',
    required: true,
    options: [],
    disabled: (item) => item.discountAmount > 0,
  },
  discountAmount: {
    placeholder: '0',
    type: 'number',
    required: true,
    options: [],
    disabled: (item) => item.discountPercentage > 0,
  },
  vatRate: {
    placeholder: '',
    type: 'select',
    required: true,
    options: [
      {
        value: '',
        label: '',
      },
      {
        value: 0,
        label: '0 %',
      },
      {
        value: 5,
        label: '5 %',
      },
      {
        value: 10,
        label: '10 %',
      },
    ],
  },
};
